import { ICellRendererParams } from 'ag-grid-community';

import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { Loader, WarningCell } from 'core/elements';
import { NumberHelper } from 'core/helpers';
import { useAgGridCellUpdateContext } from 'core/states';
import { getAgGridTableCellData } from 'core/utils';
import { QuotePartColId } from 'quotes/components/QuotePartList';
import { QuotePartHelper } from 'quotes/helpers';
import { Size } from 'theme/enums';

const QuantityCell = (props: ICellRendererParams) => {
  const { isUpdating } = useAgGridCellUpdateContext();

  const data = getAgGridTableCellData(props, QuotePartColId.QUANTITY);

  if (!data && !props?.value) {
    return DEFAULT_PLACEHOLDER;
  }

  if (!data) {
    return NumberHelper.format({ amount: props?.value });
  }

  const isUpdatingValue = isUpdating(props.node.id, QuotePartColId.QUANTITY);

  if (isUpdatingValue) {
    return <Loader size={Size.SM} style={{ justifyContent: 'flex-end', margin: 0 }} />;
  }

  return (
    <WarningCell
      content={NumberHelper.format({ amount: data?.quantity })}
      showWarning={QuotePartHelper.quantityHasWarnings(data)}
      type={QuotePartHelper.quantityWarningType(data)}
      textEllipsis
    />
  );
};

export default QuantityCell;
